import WORK_PACKAGE_TYPE from '@enums/workpackage-type';
import tabUtils from './tabs-utils';

const tabs = [
  // Scope
  {
    routeName: 'template-dates-assortment-groups',
    step: 'template-scope',
    wpTypes: [...WORK_PACKAGE_TYPE.STANDARD, WORK_PACKAGE_TYPE.ASSORTMENT_SIMPLE_SWAPS],
    position: 0,
    translationKey: 'templateScopePage.tab.datesAssortmentGroups',
    statusSection: 'scope',
    statusSubSection: 'datesAssortmentGroups',
  },
  {
    routeName: 'template-products',
    step: 'template-scope',
    wpTypes: [...WORK_PACKAGE_TYPE.STANDARD, WORK_PACKAGE_TYPE.ASSORTMENT_SIMPLE_SWAPS],
    position: 1,
    translationKey: 'templateScopePage.tab.products',
    statusSection: 'scope',
    statusSubSection: 'products',
  },
  {
    routeName: 'template-stores',
    step: 'template-scope',
    wpTypes: [...WORK_PACKAGE_TYPE.STANDARD, WORK_PACKAGE_TYPE.ASSORTMENT_SIMPLE_SWAPS],
    position: 2,
    translationKey: 'templateScopePage.tab.stores',
    statusSection: 'scope',
    statusSubSection: 'stores',
  },

  // Inputs
  {
    routeName: 'template-attributes',
    step: 'template-inputs',
    wpTypes: [...WORK_PACKAGE_TYPE.STANDARD, WORK_PACKAGE_TYPE.ASSORTMENT_SIMPLE_SWAPS],
    position: 0,
    translationKey: 'scenarioInputPage.tab.attr',
    statusSection: 'inputs',
    statusSubSection: 'attributeEditor',
  },
  {
    routeName: 'template-cann-group',
    step: 'template-inputs',
    wpTypes: [...WORK_PACKAGE_TYPE.STANDARD, WORK_PACKAGE_TYPE.ASSORTMENT_SIMPLE_SWAPS],
    position: 1,
    translationKey: 'scenarioInputPage.tab.cann-group',
    statusSection: 'inputs',
    statusSubSection: 'cannGroups',
  },
];

export default {
  ...tabUtils.generateTabRouteMap(tabs),
  ALL: tabs,
};
